import { render, staticRenderFns } from "./TextField.form-builder.vue?vue&type=template&id=774816da&"
import script from "./TextField.form-builder.vue?vue&type=script&lang=js&"
export * from "./TextField.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports